module.exports = __webpack_public_path__ + "img/電気回路_1_6_1.300dcfe6.png";